import React, { useEffect, useState } from 'react';
import './InputBox.css';
import './InpuSelectIcon.css';


// const InputAndSelectWithIconBoxSmall = ({ 
//     label, 
//     options, 
//     defaultOption, 
//     defaultValue = '', 
//     onChange, 
//     type = 'text', 
//     validators = [] 
//   }) => {
//     const [value, setValue] = useState(defaultValue);
//     const [selectedOption, setSelectedOption] = useState(defaultOption);
//     const [errors, setErrors] = useState([]);
  
//     const handleInputChange = (event) => {
//       const newValue = event.target.value;
  
//       // Ensure validators is an array
//       const validatorArray = Array.isArray(validators) 
//         ? validators 
//         : (validators ? [validators] : []);
  
//       // Run validation
//       const newErrors = validatorArray
//         .map((validator) => {
//           // Check if validator is a function
//           if (typeof validator === 'function') {
//             const result = validator(newValue);
//             // Return error message if validation fails
//             return result === true ? null : result;
//           }
//           return null;
//         })
//         .filter((error) => typeof error === 'string');
  
//       setErrors(newErrors);
  
//       // If no errors, update value and call onChange
//       if (newErrors.length === 0) {
//         setValue(newValue);
//         if (onChange) {
//           onChange({
//             type: 'input',
//             value: newValue,
//             event,
//           });
//         }
//       }
//     };
  
//     const handleSelectChange = (event) => {
//       setSelectedOption(event.target.value);
//       if (onChange) {
//         onChange({
//           type: 'select',
//           value: event.target.value,
//           event,
//         });
//       }
//     };
  
//     return (
//       <div className='small-icon-select-input-container'>
//         <svg className='icon-input' width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M8.5 0H1.5C0.675 0 0 0.675 0 1.5V14.5C0 15.325 0.675 16 1.5 16H8.5C9.325 16 10 15.325 10 14.5V1.5C10 0.675 9.325 0 8.5 0ZM3 0.75H7V1.25H3V0.75ZM5 15C4.73478 15 4.48043 14.8946 4.29289 14.7071C4.10536 14.5196 4 14.2652 4 14C4 13.7348 4.10536 13.4804 4.29289 13.2929C4.48043 13.1054 4.73478 13 5 13C5.26522 13 5.51957 13.1054 5.70711 13.2929C5.89464 13.4804 6 13.7348 6 14C6 14.2652 5.89464 14.5196 5.70711 14.7071C5.51957 14.8946 5.26522 15 5 15ZM9 12H1V2H9V12Z" fill="#424242"/>
//         </svg>
//         <div className="select-container icon-input-select">
//           <select
//             value={selectedOption}
//             onChange={handleSelectChange}
//             className='fts-13 custom-select-icon'
//           >
//             {options.map((option, index) => (
//               <option className='fts-13' key={index} value={option.value}>
//                 {option.label}
//               </option>
//             ))}
//           </select>
//           <svg className='custom-arrow' width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <path d="M4 6L0.535899 -6.52533e-07L7.4641 -4.68497e-08L4 6Z" fill="#424242"/>
//           </svg>
//         </div>
//         <input
//           className={`icon-input-box common-text fts-13 ${errors.length > 0 ? 'input-error' : ''} ${type === 'date' ? 'input-box-with-icon' : ''}`}
//           type={type}
//           value={value}
//           onChange={handleInputChange}
//           placeholder=' '
//         />
//         <label className={`lt-gray fixed-input-label ${value ? 'has-value' : ''}`}>{label}</label>
//         {errors.length > 0 && (
//           <div className="input-error-message">
//             {errors[0]}
//           </div>
//         )}
//       </div>
//     );
//   };
  
//   export default InputAndSelectWithIconBoxSmall;

const InputAndSelectWithIconBoxSmall = ({
  label,
  options,
  defaultOption,
  defaultValue = '',
  onChange,
  type = 'text',
  validators = [],
  isRequired = false,
  className = '',
  error,
}) => {
  const [value, setValue] = useState(defaultValue);
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const [errors, setErrors] = useState([]);

  // Ensure validators is always an array
  const validatorArray = Array.isArray(validators) 
    ? validators 
    : (validators ? [validators] : []);

  // Add isRequired validator if required prop is true
  const effectiveValidators = isRequired 
    ? [
      ...(typeof validatorArray === 'function' ? [validatorArray] : validatorArray),
      (val) => val !== null && val !== undefined && val !== '' || "This field is required"
    ]
    : validatorArray;

  const validateInput = (inputValue) => {
    // Run all validators
    const newErrors = effectiveValidators
      .map((validator) => {
        if (typeof validator === 'function') {
          const result = validator(inputValue);
          // Return error message if validation fails
          return result === true ? null : result;
        }
        return null;
      })
      .filter((error) => typeof error === 'string');

    return newErrors;
  };

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    
    // Validate input
    const newErrors = validateInput(newValue);
    
    // Update state
    setValue(newValue);
    setErrors(newErrors);

    // Call onChange 
    if (onChange) {
      onChange({
        type: 'input',
        value: newValue,
        event,
      });
    }
  };

  const handleSelectChange = (event) => {
    const newSelectedOption = event.target.value;
    
    setSelectedOption(newSelectedOption);
    
    if (onChange) {
      onChange({
        type: 'select',
        value: newSelectedOption,
        event,
      });
    }
  };

  const displayErrors = error ? [error] : errors;

  return (
    <div className={`small-icon-select-input-container ${className}`}>
      <svg className='icon-input' width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.5 0H1.5C0.675 0 0 0.675 0 1.5V14.5C0 15.325 0.675 16 1.5 16H8.5C9.325 16 10 15.325 10 14.5V1.5C10 0.675 9.325 0 8.5 0ZM3 0.75H7V1.25H3V0.75ZM5 15C4.73478 15 4.48043 14.8946 4.29289 14.7071C4.10536 14.5196 4 14.2652 4 14C4 13.7348 4.10536 13.4804 4.29289 13.2929C4.48043 13.1054 4.73478 13 5 13C5.26522 13 5.51957 13.1054 5.70711 13.2929C5.89464 13.4804 6 13.7348 6 14C6 14.2652 5.89464 14.5196 5.70711 14.7071C5.51957 14.8946 5.26522 15 5 15ZM9 12H1V2H9V12Z" fill="#424242"/>
      </svg>
      
      <div className="select-container icon-input-select">
        <select
          value={selectedOption}
          onChange={handleSelectChange}
          className='fts-13 custom-select-icon'
        >
          {options.map((option, index) => (
            <option className='fts-13' key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <svg className='custom-arrow' width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 6L0.535899 -6.52533e-07L7.4641 -4.68497e-08L4 6Z" fill="#424242"/>
        </svg>
      </div>
      
      <input
        className={`icon-input-box common-text fts-13 ${errors.length > 0 ? 'input-error' : ''} ${type === 'date' ? 'input-box-with-icon' : ''}`}
        type={type}
        value={value}
        onChange={handleInputChange}
        placeholder=' '
        autoComplete="off"
        autoCorrect="off"
        spellCheck="false"
      />
      
      <label className={`lt-gray fixed-input-label ${value ? 'has-value' : ''}`}>
        {label}
      </label>
      
      {displayErrors.length > 0 && (
        <div className="input-error-message fts-12">
          {displayErrors[0]}
        </div>
      )}
    </div>
  );
};

export default InputAndSelectWithIconBoxSmall;